import { useState } from "react";
import { Button } from "@/components/ui/button.tsx";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem
} from "@/components/ui/dropdown-menu.tsx";
import IcoUser from "@/assets/icons/ico-user-img.svg?react";
import IconChevronDown from "@/assets/icons/ico-chevron-down.svg?react";
import { cn } from "@/lib/utils.ts";

interface LogoutComboboxProps {
  userId: string
  label: string
  onLogout: () => void
}

export function LogoutCombobox({ userId, label, onLogout }: LogoutComboboxProps) {
  const [open, setOpen] = useState(false)

  return (
    <div className="flex">
      <DropdownMenu open={open} onOpenChange={setOpen}>
        <DropdownMenuTrigger asChild>
          <div className="flex items-center gap-2 cursor-pointer select-none">
            <IcoUser />
            <Button
              variant="ghost"
              size="lg"
              className="text-sm text-grayscale-70 font-medium p-0"
            >
              {userId}
            </Button>
            <IconChevronDown className={cn("w-4 h-4 transition ease-in-out", open ? "rotate-180" : "")} />
          </div>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem onClick={() => onLogout()}>
            {label}
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  )
}